import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import TransfersSummary from './TransfersSummary/TransfersSummary';
import AccountSummary from './AccountSummary';
import { accordion } from './AccordionCustom.sx';
import logger from 'app/utils/logger';
import CardSummary from './CardSummary';
import EmployeeSummary from 'app/components/AccordionCustom/EmployeeSummary';
import { Menu, MenuItem } from '@mui/material';
import { menuItems } from 'app/components/LastOperations/LastOperations.sx';
import CreditSummary from './CreditSummary';

interface Status {
  value: string;
  label: string;
  icon: JSX.Element;
}

interface AccordionProps {
  id?: number;
  headerText: string;
  pageName: string;
  position?: string;
  accountText?: string;
  creditNum?: string;
  amount?: string;
  status?: Status;
  email?: string;
  totalBalance?: number;
  paymentDate?: string;
  paymentDate2?: string;
  detailsAccordion?: React.ReactNode;
  anchorEl?: any;
  activeAnchor?: string;
  handleMenuClick?: (e: any, status: any, id: any) => void;
  handleClose?: () => void;
  currency?: any;
  img?: any;
  employeeStatus?: any;
}
const AccordionCustom = (props: AccordionProps) => {
  const {
    headerText,
    detailsAccordion,
    pageName,
    accountText,
    amount,
    status,
    email,
    position,
    anchorEl,
    activeAnchor,
    handleMenuClick,
    handleClose,
    id,
    creditNum,
    totalBalance,
    paymentDate,
    paymentDate2,
    currency,
    img,
    employeeStatus,
  } = props;
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (pageName === 'accounts' || pageName === 'cards') {
      setOpen(false);
    }
  }, []);

  return (
    <Accordion
      disabled={status?.value === 'closed'}
      disableGutters
      sx={accordion}
      expanded={open}
      onChange={(e: any, expanded) => {
        if (e.target.id !== 'editIcon') {
          setOpen(expanded);
        }
      }}
    >
      {pageName === 'transfer' && <TransfersSummary headerText={headerText} />}
      {pageName === 'accounts' && (
        <AccountSummary
          open={open}
          setOpen={setOpen}
          headerText={headerText}
          accountText={accountText}
          amount={amount}
          status={status}
          currency={currency}
        />
      )}
      {pageName === 'cards' && (
        <CardSummary
          open={open}
          setOpen={setOpen}
          headerText={headerText}
          accountText={accountText}
          amount={amount}
          status={status}
          currency={currency}
          img={img}
        />
      )}
      {pageName === 'profile' && (
        <EmployeeSummary
          id={id}
          headerText={headerText}
          status={status}
          email={email}
          position={position}
          anchorEl={anchorEl}
          employeeStatus={employeeStatus}
          activeAnchor={activeAnchor}
          handleMenuClick={handleMenuClick}
          handleClose={handleClose}
        />
      )}
      {pageName === 'credits' && (
        <CreditSummary
          open={open}
          setOpen={setOpen}
          headerText={headerText}
          creditNum={creditNum}
          totalBalance={totalBalance}
          paymentDate={paymentDate}
          paymentDate2={paymentDate2}
        />
      )}
      {detailsAccordion}
    </Accordion>
  );
};

export default AccordionCustom;
